(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["quick-add-to-cart"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-quick-add]');
    if (!button || button.disabled) return;

    var variantId = button.getAttribute('data-variant-id');
    var originalLabel = button.textContent;
    var labelLoading = button.getAttribute('data-label-loading') || originalLabel;
    var labelAdded = button.getAttribute('data-label-added') || originalLabel;
    var labelError = button.getAttribute('data-label-error') || originalLabel;
    var labelErrorGeneric = button.getAttribute('data-label-error-generic') || labelError;
    button.disabled = true;
    button.textContent = labelLoading;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (data) {
            throw new Error(data.description || labelErrorGeneric);
          });
        }
        return fetch('/cart.js');
      })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var badge = document.querySelector('[data-cart-badge]');
        var link = document.querySelector('[data-cart-link]');
        if (badge) {
          badge.textContent = cart.item_count;
          badge.hidden = cart.item_count === 0;
        }
        if (link) {
          var ariaTemplate = link.getAttribute('data-cart-aria-template');
          if (ariaTemplate) {
            link.setAttribute('aria-label', ariaTemplate.replace('__COUNT__', cart.item_count));
          }
        }
        document.dispatchEvent(new CustomEvent('dapeppa:cart:updated', { detail: cart }));
        button.textContent = labelAdded;
        setTimeout(function () {
          button.textContent = originalLabel;
          button.disabled = false;
        }, 1500);
      })
      .catch(function () {
        button.textContent = labelError;
        setTimeout(function () {
          button.textContent = originalLabel;
          button.disabled = false;
        }, 2000);
      });
  });
  } catch(e) { console.error(e); }
})();

})();
